export default __webpack_public_path__ + "static/media/plus.27ee4d28.svg";